import { StatsProps } from 'types/stats';

import './stats-card.scss';

export const StatsCard = ({
  icon,
  title,
  value,
  className = '',
  variant = 'default',
}: StatsProps) => {
  const variantStyles = {
    default: {
      wrapper: 'stats-default',
      content: 'content-default',
    },
    'highlighted-title': {
      wrapper: 'highlighted-wrapper',
      content: 'highlighted-content',
    },
  };

  const { wrapper, content } = variantStyles[variant];

  return (
    <article className={`${wrapper} ${className}`}>
      <div className="icon">{icon}</div>
      <div className={`${content}`}>
        <h4 className="title">{title}</h4>
        <strong className="value">{value}</strong>
      </div>
    </article>
  );
};
